import {Component} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-tutorial-page',
    templateUrl: './tutorial-page.component.html',
    styleUrls: ['./tutorial-page.component.scss'],
    standalone: false
})
export class TutorialPageComponent {
  id: string;
  videoUrl: SafeResourceUrl;

  constructor(public router: Router, private readonly route: ActivatedRoute, private readonly sanitizer: DomSanitizer) {  }

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        this.id = params.id;
        this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/' + this.id + '?h=be1ff191e3&badge=0&autopause=0&player_id=0&app_id=58479');
      });
  }
}
